import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {UserDetails} from "../../user-details/user-details.component";
import {UsefulLinks} from "../../useful-links/useful-links.component";
import {WelcomeUser} from "../../welcome-user/welcome-user.component";
import {UserBalance} from "../../balance-box/user-balance.component";
import { UserMenuClosePCButtonBox } from "../close-button/boxes/user-menu-close-pc-button.box";
import { UserMenuCloseIconBox } from "../close-button/boxes/user-menu-close-icon.box";
import {MiniSafezoneComponent} from "../mini-safezone/mini-safezone.component";
import {UserMenuHeaderBox} from "./boxes/user-menu-header.box";
import {UserMenuScrollWrapperBox} from "./boxes/user-menu-scroll-wrapper.box";
import {SideMenuHorizontalLineBox} from "../../side-menu/horizontal-ruler/side-menu-horizontal-line.box";

interface IUserMenuPcProps {
  closeMenu: () => void;
}

export class UserMenuPc extends OrbitComponent<IUserMenuPcProps> {

  private _renderUserMenuHeader() {
    const CloseIcon = this.services.theme.currentTheme.icons.closeIcon;
    return (
      <UserMenuHeaderBox className="cy-user-menu-header-box">
        <WelcomeUser/>
        <UserMenuClosePCButtonBox>
          <UserMenuCloseIconBox className="cy-user-menu-close-btn" onClick={this.props.closeMenu}>
            <CloseIcon size={1.4} />
          </UserMenuCloseIconBox>
        </UserMenuClosePCButtonBox>
      </UserMenuHeaderBox>
    );
  }

  render() {
    return (
      <>
        {this._renderUserMenuHeader()}
        <UserMenuScrollWrapperBox>
          <UserDetails />
          <UserBalance />
          <MiniSafezoneComponent/>
          <SideMenuHorizontalLineBox/>
          <UsefulLinks />
        </UserMenuScrollWrapperBox>
      </>
    );
  }
}
